import Vue from 'vue'
import 'es6-promise/auto'
import Vuex from 'vuex'
//import $ from 'jquery'

import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'
import * as types from './types'
//import * as state from './states'

//import router from '../router'

Vue.use(Vuex);



const state = {
  //server: "http://localhost:65043",
  //server: "http://10.2.2.129:54571",
  //settings
  isPlugin: false,
  isAgent: false,
  appConf: {
    isCIS: true,
    status: {}
  },
  goToObject: {
    to: {
      path: "",
      revisionId: "",
      id: ""
    },
    back: {
      path: "",
      revisionId: "",
      id: ""
    }
  },
  s_skinVariant: "dark", //dark or light
  globalSettings: {
    displayLocalLinks: true,
    displayHttpLinks: true,
    doubleApproval: true,
    placingPrototype: true,
    deletionOfElements: true,
    cleanDependencies: true,
    IPCTopColour: "#9533b1",
    IPCBottomColour: "#3366CC",
    advancedPermissions: true,
    fixedNumberInPartNumber: true,
    SEDetails: false

  },
  usersQuantity: 0,
  langVariant: "en",
  isSettings: false,//show/hide settings window
  isAlert: false, //show/hide alert window
  alertContainer: {}, //text to display in footer
  alertObject: {}, //object for alert information
  loader: {
    visible: false,
    text: ""
  },
  isModalComponent: false,
  modalComponentObject: {},
  isModalSearchPartsComponent: false,
  modalSearchPartsComponentObject: {},
  alertTable: [],
  dataNotifications: "",

  saveStatus: false,

  viewForModule: "",
  sectionPrefix: "",
  outerData: false,
  isSecondLevel: "",

  //auth
  logged: localStorage.getItem('token'),
	currentUser: { login: localStorage.getItem('user'), role: localStorage.getItem('role'), userId: localStorage.getItem('userId')},
  selectedUser: {},
  createUserForm: {},


  //dashboard
  d_dashboardWidgets: [],
  d_filteredData: [],
  d_widgetsSettings: {
    ActiveParts: true,
    PendingParts: true,
    RoHSParts: true,
    MyTasks: true,
    Tasks: true,
    EndOfParts: true,
    LibStatuses: true,
    ActiveLibraries: true,
    PendingLibraries: true,
    MyRequests: true,
    MyRequestedElements: true,
  },

  //All
  navBarUniqueId:0,
  dataTree: {},//tree category data

  dataSearchPartsTree: {},


  propertyId: "", //property id for parts

  reloadedAfterActionComplex: {
    counter: 0
  },
  createPropertyForm: {},
  isEditPropertyForm: false,
  propertyToSaving: [],
  propertyToSavingUL: [],
  libraryFilesToSaving: [],
  partRevisionId: "",

  externalSearchResponseResult: [],
  selectedSearchedRows: {},
  derivedNewProps: [],

  pm_activeActions: [],
  lm_activeActions: [],
  projm_activeActions: [],
  pm_activeFilters: [], //list of active filters
  lm_activeFilters: [], //list of active filters
  projm_activeFilters: [], //list of active filters

  authorityToChange: false,

  dataTable: "", //data for datatable in main view of modules
  selectedRows: [], //data from selected row from datatable
  //selectedRowsSearch: [], //data from selected row from datatableSearch
  filters: [], //list of filters
  revisionHistory:[], //data for datatable for revision history
  detailsData: {},
  selectedRevisionRow: [], //data from selected row in revision history table
  formDetailsData: {},
  selectedFormRow: [],
  formTableInstance: {}, //reference to table which can be modify for details, new or derive view
  selectedIndexFormRow: "",
  formProperty: "",
  tasksTable: [], //data for taks list
  tasksTableDetails: {}, //data for tasks list in details
  eventTaskResponse:{}, //response for action event on tasks
  pinsTable: {}, // table for pins
  pinsTableDetails: {},// table for pins in details
  dependOnTable: {}, //table for dependencies
  dependOnTableDetails: {},//table for dependencies in details
  useInTable: {},//table for dependencies
  useInTableDetails: {},//table for dependencies in details
  possibleValueForCombo: [],
  dataTableSearched: "", //data for datatable in search view of modules
  searchingObject: {
    searchString: "",
    choosenProviders: []
  },
  processId: "",
  // symbolsTable: {},
  // footprintsTable: {},
  selectedFootprints: [],
  selectedSymbols: [],
  selectedAltSymbols: [],
  categoryMapping: [],
  filteredData: "",
  currentSymbol: {},
  newSubCategory: "",

  newRenamingValue: {},
  newMovingCategory: {},
  delegationForm: {},
  transferOwnershipForm: {},

  routingData: [],
  tabData: {},
  alertModalContainer: {},


  //d - dasboard


  //permissions

  createGroupForm: {},
  permissionGroup: [],


  //pm - part manager
  existingTypes: [],

  //categories for parts
  //selectedTreeItem: "",
  selectedTreeItemObject: {
    categoryId: 1,
    category: "All components",
    name: "All components",
    parentId: 0,
    type: "",
    image: "default",
    children: [],
    depth: 1,
    libraryType:null,

  },
  selectedTreeItem: "",//select item from tree category
  elementCategory:"All components",
  //reloadTreeComponet:false,
  reloadAfterDeleteTreeItem: false,
  //selectedTreeItemObject:"",

  selectedSearchPartsTreeItem: "",
  selectedSearchPartsTreeItemObject: {
    categoryId: 1,
    category: "All components",
    name: "All components",
    parentId: 0,
    type: 0
  },
  elementCategorySearchParts:"All components",

  importedFileId: "",
  previewParts: [],
  mappedFields: [],

  eventTaskForm: "",

  alternativePartsToBind: [],
  selectedAlternative: {},
  allActiveImportedParts: {
    allActive: false,
    type: "Electric"
  },
  notImportedParts: [],
  duplicatePartNumber: 0,
  newAssemblyForm: {},
  selectedAssemblyRow: {},
  assemblyQuantity: 1,
  tabStatus: 0,
  partSE: {},

  //lm - library manager
  selectedTreeItem: "",
  selectedTreeLibraryItemObject: {
    categoryId: 1,
    category: "All libraries",
    name: "All libraries",
    parentId: 0,
    type: 0,
    libraryType: null
  },
  categoryLibraryMapping: [],
  dataLibraryTree: {},
  //reloadTreeLibraryComponet:false,
  reloadAfterDeleteTreeLibraryItem: false,
  elementCategoryLibrary: "All libraries",

  libStatuses: [],
  importLibraryArray: [],

  dataLibrariesAfterBulkImport: [],

  importLibCurrentObject: {},
  importLibCurrentObject_Result: {},
  dataLibrariesAfterBulkApprove: [],

  //p - processes manager

  p_showProcessDiagram: false,

  //projm - Projects

  categoryProjectMapping: [],
  dataProjectTree: {},
  //reloadTreeProjectComponet:false,
  reloadAfterDeleteTreeProjectItem: false,
  selectedTreeProjectItemObject:"",
  elementCategoryProject:"All projects",

  categoryFolderMapping: [],
  dataFolderTree: {},
  //reloadTreeFolderComponet:false,
  reloadAfterDeleteTreeFolderItem: false,
  selectedTreeFolderItemObject:"",
  elementFolderProject: "All projects",

  subfolderForm: {},
  variantFolderForm: {},
  variants: [],


  createProjectForm: {},
  selectedProjectRow: {},

  bomDescription: {
    description: ""
  },

  selectedPartBomRow: {},
  isBomInProject: false,
  selectedDocument: {},
  bomProperties: [],

  selectedBomRow: [],
  delegatedResource: false,
  isBom: false,
  importBomTypeForm: {},
  createBomVariantForm: {},
  bomPartObjectForm: {},

  checkboxVariant: null,

  selectedSearchPartRows: null,

  noIpcImage: false,
  libraryULObject: {},
  buttonsStateModalObject: {},

  projectSpecForm: {},

  partInBomToReload: {},

  bomDetails: {},
  projectDetails: {},

  //rm - Requests

  requestCreateForm: {},

  rm_activeFilters: [],
  rm_activeActions: [],

  requestFilesToSaving: [],
  propertyRequestToSaving: [],

  selectedRequestRows: [],
  selectedAssignUser: {},
  requestDetails: {},
  requestTaskObject: {},

}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  types

})




// WEBPACK FOOTER //
// ./src/store/index.js